import { post,get,postSSR,postAES } from "@/api/request"

// 拍品详情
export const getProDetail = params => postSSR("/v3/auctions/detail", params)
// 拍品详情推荐
export const getProReco = params => post("/v1/recommend/detail/auction", params)
// 拍品详情拍品列表
export const getProList = params => postAES("/v3/special/auctions/list", params)
// 拍品详情拍卖专场
export const getProSession = params => postAES("/v3/special/list", params)
// 推荐艺术家
export const getProArtist = params => get("/v1/recommand/artist", params)
export const getReco = params => get("/v1/grain/lists", params)
export const getBidList = params => post("https://auction-bid.artron.net/v2/bid/list", params)
export const getAuctionInfo = params => post("https://auction-bid.artron.net/v2/auction/info", params)